import Vue from 'vue';
import Router from 'vue-router';

const GameView = () => import(/* webpackChunkName: "game-view" */ '@/components/GameView');
const MessageView = () => import(/* webpackChunkName: "message-view" */ '@/components/MessageView');
const RedirectView = () => import(/* webpackChunkName: "message-view" */ '@/components/RedirectView');

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior(to,from) {
    if(!(to.meta.showModal || from.meta.showModal)) {
      if('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({top: 0, behavior: 'smooth'});
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
  routes: [ // Order is important
    {
      path: '/GameView/:provider',
      name: 'GameView',
      component: GameView,
    },
    {
      path: '/MessageView',
      name: 'MessageView',
      component: MessageView,
    },
    {
      path: '/Redirect',
      alias: '/redirect',
      name: 'RedirectView',
      component: RedirectView,
    },
  ]
});

export default router;
